<mat-form-field (click)="onInputClick(); false">
  <mat-label>{{ ctx.placeholder }}</mat-label>
  <input matInput [matDatepicker]="picker" [readonly]="true" [formControl]="ctx.control" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker [startAt]="ctx.start" disabled="false" #picker></mat-datepicker>
</mat-form-field>
